import { combineReducers } from "redux";
import { reducer as toastrReducer } from "react-redux-toastr";
import events from "./events";
import client from "./client";
import filters from "./filters";
import user from "./user";
import buyerIdentity from "./buyer-identity";
import purchase from "./purchase";
import infoMessage from "./info-message";

export default combineReducers({
  events: events.reducer,
  client: client.reducer,
  filters: filters.reducer,
  user: user.reducer,
  buyerIdentity: buyerIdentity.reducer,
  purchase: purchase.reducer,
  infoMessage: infoMessage.reducer,
  toastr: toastrReducer
});
